import { Component, inject, effect, computed, ViewChild, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PartiesManagementService } from '../../service/parties-management.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { AuthService } from '@services/core/auth.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PartyOverviewComponent } from '../party-overview/party-overview.component';
import { AddPartyComponent } from '../add-party/add-party.component';
import { PartyListComponent } from '../../components/party-list/party-list.component';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { MobileFooterComponent } from 'app/core/components/mobile-footer/mobile-footer.component';
import { AdvancedFilterComponent, FilterField } from 'app/core/components/advanced-filter/advanced-filter.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { MasterDetailNav } from 'app/core/service/utils/master-detail-nav.service';


registerLocaleData(localeEs);

@Component({
  selector: 'app-party-management',
  templateUrl: './party-management.component.html',
  styleUrls: ['./party-management.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    NgbModule,
    PartyOverviewComponent,
    FormsModule,
    AddPartyComponent,
    PartyListComponent,
    PageHeaderComponent,
    MobileFooterComponent,
    AdvancedFilterComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [PartiesManagementService, { provide: LOCALE_ID, useValue: 'es-ES' }]
})
export class PartyManagementComponent {
  public Toast = Swal.mixin({
    toast: true, position: 'top-end'
    , showConfirmButton: false, timer: 2000, timerProgressBar: true
  })
  employeeType = input<number>();
  activeChange = output<boolean>();
  @ViewChild('preview', { static: true }) preview: any;
  @ViewChild('advFilter') advFilter?: AdvancedFilterComponent;
  @ViewChild('modalForm', { static: true }) modalForm: any;
  private modalRef: NgbModalRef;
  readonly authService = inject(AuthService)
  public entity;
  public order: boolean = true;
  public orderColName: string = 'partyNames'
  public isLoading = true;
  public rows = Array.from({ length: 15 }, (_, i) => i + 1);
  public partiesDataReport;
  public pdfSrc
  public user;
  public entities;
  public showOverview: boolean;
  public addParty: boolean;
  public partyHeaderAction: 'save' | 'finalize' | 'next' | null = null;
  public showFilters: boolean = false; // Deprecated or keep for general state? I'll remove it or ignore it.
  public showEntityFilter: boolean = false;
  public showStatusFilter: boolean = false;
  public isClaimModeActive = false;
  public pageHeaderTitle = 'Socios';
  public pageHeaderShowBack = false;
  public appSettings = inject(AppSettings);
  private md = inject(MasterDetailNav);
  @ViewChild('overview') overview?: PartyOverviewComponent;
  @ViewChild('addPartyComp') addPartyComp?: AddPartyComponent;
  partyOut;
  private didInitialSelect = false;
  private readonly selectedPartyKey = 'fpv.socios.selectedUuid';

  appHasAccess: string[] = [];

  public partiesData;
  public partiesDataTemp;
  public partiesSelected = [];
  public ngPartiesData;
  public ngEntitydata;
  public entitiesSelected = [];
  public ngStatusData;
  public statusSelected = [];
  public searchQuery = '';
  advancedFilterFields: FilterField[] = [
    { key: 'party', label: 'Socio / RUT' },
    { key: 'entity', label: 'Entidad' },
    { key: 'status', label: 'Estado' },
  ];
  activeAdvancedFilters = signal<Array<{ field: string; value: string }>>([]);


  constructor(private partiesManagementService: PartiesManagementService,
    private modalService: NgbModal,
    private route: ActivatedRoute) {
    effect(() => {
      this.entity = this.authService.sharingEntity();
      this.user = this.authService.userData();
      this.authService.sharingRole();
      this.authService.sharingIdentity();
      if (this.isPortalUser() && this.partiesDataTemp?.length && !this.partyOut) {
        this._selectLinkedParty();
      }
    });
    this.md.urlChanges$.pipe(takeUntilDestroyed()).subscribe(() => this.syncFromRoute());
  }

  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';





  /*abre los modales */
  open(content, size: 'md' | 'lg' | 'xl' = 'lg') {
    this.modalRef = this.modalService.open(content, { size: size });
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }



  ngOnInit(): void {
    this.getParties();
    // this.getEntitiesData();
  }


  showLoading(msg) {
    Swal.fire({
      title: msg,
      text: 'Por favor, espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  hideLoading() {
    Swal.close();
  }

  changeAddParty(_event?: boolean) {
    this.addParty = false;
    this.partyHeaderAction = null;
    this.md.go(this.md.parties());
    this.getParties();
  }

  get showListMobileActions(): boolean {
    return this.appSettings.isMobile()
      && !this.addParty
      && !this.partyOut
      && !this.isClaimModeActive
      && !this.overview?.showAddPartyView()
      && !this.overview?.showAddClaim();
  }

  get showMobileFooter(): boolean {
    if (this.addParty
      || this.overview?.showAddPartyView()
      || this.overview?.showAddClaim()
      || this.overview?.showTransferForm()
      || this.overview?.showAddBenefit()
      || this.overview?.showBajaForm()
      || this.overview?.showViewUnsubscribe()) {
      return false;
    }
    return this.showListMobileActions || !!this.headerPrimaryAction;
  }

  get headerPrimaryAction(): 'save' | 'finalize' | 'next' | null {
    if (this.addParty) return this.addPartyComp?.headerEditorAction() ?? this.partyHeaderAction ?? 'save';
    return this.overview?.currentHeaderAction() ?? null;
  }

  get headerPrimaryLabel(): string {
    const action = this.headerPrimaryAction;
    if (action === 'finalize') {
      // En siniestro: dejar daño en revisión (no envía). En alta de socio: Finalizar.
      if (this.overview?.showAddClaim()) return 'Dejar en revisión';
      return 'Finalizar';
    }
    if (action === 'next') return 'Siguiente';
    return 'Guardar';
  }

  get isHeaderActionSaving(): boolean {
    if (this.addParty) return !!this.addPartyComp?.isEditorSaving();
    return !!this.overview?.isEditorSaving();
  }

  get canDeleteFromHeader(): boolean {
    if (this.addParty) return !!this.addPartyComp?.canDeleteFromHeader();
    return !!this.overview?.canDeleteFromHeader();
  }

  runHeaderPrimaryAction() {
    if (this.addParty) {
      this.addPartyComp?.saveEditorFromHeader();
      return;
    }
    this.overview?.saveEditorFromHeader();
  }

  deleteFromHeader() {
    if (this.addParty) {
      this.addPartyComp?.deleteFromHeader();
      return;
    }
    this.overview?.deleteFromHeader();
  }

  closeOverviewParty(event) {
    this.partyOut = null;
    sessionStorage.removeItem(this.selectedPartyKey);
    this.resetPageHeader();
    this.md.go(this.md.parties());
    this.getParties();
  }

  get showPartyListBack(): boolean {
    return this.appSettings.isMobile() && !!this.partyOut && !this.isPortalUser();
  }

  get headerShowBack(): boolean {
    return this.pageHeaderShowBack || this.showPartyListBack;
  }

  onHeaderContext(ctx: { title: string; showBack: boolean }) {
    this.pageHeaderTitle = ctx.title;
    this.pageHeaderShowBack = ctx.showBack;
  }

  resetPageHeader() {
    this.pageHeaderTitle = 'Socios';
    this.pageHeaderShowBack = false;
  }

  onPageHeaderBack() {
    if (this.overview?.showBajaForm() || this.overview?.showViewUnsubscribe()) {
      this.overview.closeBajaForm();
      return;
    }
    if (this.overview?.showTransferForm()) {
      this.overview.closeTransferForm();
      return;
    }
    if (this.overview?.showAddClaim() && this.overview?.addClaimComp?.isEditingDetail()) {
      this.overview.addClaimComp.closeDetailEditor();
      return;
    }
    const st = this.md.parse();
    if (st.area === 'socios' && st.dano && st.partyUuid) {
      this.overview?.addClaimComp?.closeDetailEditor();
      this.md.go(this.md.claim(st.partyUuid, st.claimUuid || 'nuevo'));
      return;
    }
    this.md.back(this.md.parties());
  }

  openNewParty() {
    this.md.go(this.md.newParty());
  }

  showOverviewParty(party) {
    if (!party?.uuid) return;
    const st = this.md.parse();
    if (st.partyUuid === String(party.uuid) && !st.nuevo) {
      this.applyParty(party);
      return;
    }
    this.md.go(this.md.party(party.uuid));
  }

  private applyParty(party) {
    this.partyOut = party;
    if (party?.uuid) {
      sessionStorage.setItem(this.selectedPartyKey, String(party.uuid));
    }
  }

  private syncFromRoute() {
    const st = this.md.parse();
    if (st.area !== 'socios') return;
    this.addParty = !!st.nuevo;
    if (st.nuevo) {
      this.partyOut = null;
      return;
    }
    if (!st.partyUuid) {
      if (!this.isPortalUser()) {
        this.partyOut = null;
        sessionStorage.removeItem(this.selectedPartyKey);
        this.resetPageHeader();
      }
      return;
    }
    const list = this.partiesData?.length ? this.partiesData : (this.partiesDataTemp || []);
    const found = list.find((p) => String(p.uuid) === String(st.partyUuid));
    if (found) this.applyParty(found);
  }

  private linkedPartyUuid(): string | null {
    const identity = this.authService.sharingIdentity() as any;
    return identity?.partyUuid || identity?.party?.uuid || null;
  }

  private _selectLinkedParty() {
    const partyUuid = this.linkedPartyUuid();
    const list = this.partiesData?.length ? this.partiesData : (this.partiesDataTemp || []);
    if (!list.length) return;
    const linked = list.find((p) => partyUuid && String(p.uuid) === String(partyUuid));
    const target = linked || (this.isPortalUser() ? list[0] : null);
    if (target?.uuid) this.md.replace(this.md.party(target.uuid));
  }

  private _restoreSelection() {
    if (this.md.parse().partyUuid) return;
    if (this.isPortalUser()) {
      this._selectLinkedParty();
      return;
    }
    const partyIdParam = this.route.snapshot.queryParams['partyId'];
    const storedUuid = sessionStorage.getItem(this.selectedPartyKey);
    const list = this.partiesData || [];
    const found = list.find((p) =>
      (partyIdParam && (String(p.id) === String(partyIdParam) || String(p.uuid) === String(partyIdParam)))
      || (storedUuid && String(p.uuid) === String(storedUuid))
    );
    if (found) {
      if (this.appSettings.isMobile() && !partyIdParam) return;
      this.md.replace(this.md.party(found.uuid));
    }
  }

mapResponseToPartiesData(response) {
    const source = Array.isArray(response) ? response : (response?.data || []);
    const mappedResponse = source.map(p => ({
        ...p,
        partyRut: p.rut,
        partyNames: p.names,
        partyBirthday: p.birthday,
        partyMail: p.mail,
        partyMobileNumber: p.mobileNumber,
        statusName: p.status?.name,
        statusIsActive: p.status?.isActive,
        partyTypeName: p.partyType?.name,
        entityCode: p.entity?.code ?? '',
        entityName: p.entity?.name ?? '',
        entityCampus: p.entity?.campus ?? ''
      })); 
      return mappedResponse.sort((a, b) => (a.statusSlug || '').localeCompare(b.statusSlug || ''));
    } 


  /**metedo al precionar el boton de mostrar u ocultar filtro */





  /** Rol Usuario: sin listado, solo su socio. */
  readonly isPortalUser = computed(() => {
    this.authService.sharingRole();
    this.authService.sharingIdentity();
    return this.authService.isUserRole();
  });

  getParties() {
    this.isLoading = true;
    this.partiesManagementService.getParties().subscribe(response => {
      this.isLoading = false;
      this.hideLoading()

      // Mapear la nueva estructura anidada (ORM) a la estructura plana que espera la vista
      const mappedResponse = this.mapResponseToPartiesData(response);
      this.partiesData = mappedResponse;
      this.partiesDataTemp = JSON.parse(JSON.stringify(mappedResponse));
      this.ngPartiesData = this.formatDataNgSelectParties(this.partiesData);
      this.entities = this.getEntitiesGrouped(this.partiesData);
      this.ngEntitydata = this.formatDataNgSelectEntities(this.entities);
      this.ngStatusData = this.getStatusGrouped(this.partiesData)
      this.changeSelect();

      this.syncFromRoute();
      if (this.isPortalUser() && !this.md.parse().partyUuid) {
        this._selectLinkedParty();
      } else if (!this.md.parse().partyUuid && !this.didInitialSelect) {
        this._restoreSelection();
      }
      this.didInitialSelect = true;
    },
      error => {
        this.Toast.fire({ icon: 'warning', title: 'Error al obtener los datos ' + error });
        this.hideLoading();
        this.isLoading = false;
      })
  }

  getStatusGrouped(status) {
    const uniqueMap = new Map<string, any>();

    for (const p of status) {
      if (!uniqueMap.has(p.statusSlug)) {
        uniqueMap.set(p.statusSlug, {
          slug: p.statusSlug,
          name: p.statusName,
          isActive: p.statusIsActive ?? 0
        });
      }
    }

    // Convertimos el mapa en arreglo
    return Array.from(uniqueMap.values()).sort((a, b) => (a.slug || '').localeCompare(b.slug || ''));

  }

  getEntitiesGrouped(parties) {
    const uniqueEntitiesMap = new Map<number, any>();

    for (const p of parties) {
      if (!uniqueEntitiesMap.has(p.entityCode)) {
        uniqueEntitiesMap.set(p.entityCode, {
          entityCode: p.entityCode,
          description: `${p.entityName} (${p.entityCampus})`,
          entityName: p.entityName,
          entityCampus: p.entityCampus
        });
      }
    }

    // Convertimos el mapa en arreglo
    return Array.from(uniqueEntitiesMap.values());
  }

  getEntitiesData() {
    this.partiesManagementService.getEntities().subscribe(response => {
      this.entities = response;
      this.ngEntitydata = this.formatDataNgSelectEntities(this.entities);
    },
      error => {
        console.log('error getFdrEntitiesData', error)
      })
  }

  formatDataNgSelectEntities(entities) {
    return entities.map(entity => {
      return {
        code: entity.entityCode,
        description: entity.entityCode + ' - ' + entity.entityCampus,
        disabled: false,
        isActive: true
      }
    });
  }

  changeSelect() {
    this.applyListFilters();
  }

  onAdvancedFiltersChange(filters: Array<{ field: string; value: string }>) {
    this.activeAdvancedFilters.set(filters);
    this.applyListFilters();
  }

  applyListFilters() {
    let list = [...(this.partiesDataTemp || [])];
    if (this.statusSelected.length > 0) {
      list = list.filter(party => this.statusSelected.includes(party.statusSlug));
    }
    if (this.partiesSelected.length > 0) {
      list = list.filter(party => this.partiesSelected.includes(party.uuid));
    }
    if (this.entitiesSelected.length > 0) {
      list = list.filter(party => this.entitiesSelected.includes(party.entityCode));
    }
    const q = (this.searchQuery || '').trim().toLowerCase();
    if (q) {
      list = list.filter(party => this._matchPartySearch(party, q));
    }
    const filters = this.activeAdvancedFilters() ?? [];
    if (filters.length) {
      list = list.filter(party => filters.every(rule => this._matchAdvancedRule(party, rule)));
    }
    this.partiesData = list;
    this.syncPartySelection();
  }

  private _matchPartySearch(party: any, q: string): boolean {
    const hay = `${party.partyNames ?? ''} ${party.partyRut ?? party.rut ?? ''} ${party.entityCode ?? ''} ${party.entityName ?? ''}`.toLowerCase();
    return hay.includes(q);
  }

  private _matchAdvancedRule(party: any, rule: { field: string; value: string }): boolean {
    const val = (rule?.value ?? '').toLowerCase();
    if (!val) return true;
    if (rule.field === 'party') {
      return `${party.partyNames ?? ''} ${party.partyRut ?? party.rut ?? ''}`.toLowerCase().includes(val);
    }
    if (rule.field === 'entity') {
      return `${party.entityCode ?? ''} ${party.entityName ?? ''} ${party.entityCampus ?? ''}`.toLowerCase().includes(val);
    }
    if (rule.field === 'status') {
      return `${party.statusSlug ?? ''} ${party.statusName ?? ''} ${party.status?.name ?? ''}`.toLowerCase().includes(val);
    }
    return true;
  }

  // Sincroniza el socio seleccionado al buscar en ng-select
  syncPartySelection() {
    if (this.partiesSelected.length > 0) {
      const lastUuid = this.partiesSelected[this.partiesSelected.length - 1];
      const match = this.partiesData.find(p => p.uuid === lastUuid) ?? this.partiesData[0];
      if (match) this.showOverviewParty(match);
    } else if (this.partyOut && !this.partiesData.some(p => p.uuid === this.partyOut.uuid)) {
      if (this.isPortalUser()) this._selectLinkedParty();
      else this.partyOut = null;
    }
  }

  changeSelectEntity() {
    if (this.entitiesSelected.length > 0) {
      this.partiesData = this.partiesData.filter(party => this.entitiesSelected.includes(party.entityCode));
    }
  }


  /**ordenar datos */
  orderCol(col: string) {
    this.order = !this.order;
    this.orderColName = col;
  }



  formatNumber(value: any): string {
    if (value == null) return '';
    return parseFloat(value).toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  formatDataNgSelectParties(params) {
    return params.map(party => {
      return {
        id: party.id,
        uuid: party.uuid,
        rut: party.partyRut,
        rutNames: (party.partyRut || '') + ' - ' + (party.partyNames || ''),
        names: party.partyNames
      }
    });
  }




  dataExcel() {
    return this.partiesDataReport.map(detail => {
      return {
        Entidad: detail.entityCode,
        Rut: detail.accountRut,
        Nombres: detail.accountName,
        Total: detail.total ? detail.total : detail.startBalance
      }
    });
  }


  /**Obtener la fecha en formato 04/12/2024 09:36:44  */
  getDate() {
    let date = new Date();
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
    const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
    const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
    return `${formattedDate}_${formattedTime}`;
  }

  exportToExcel(): void {
    const worksheet = XLSX.utils.json_to_sheet(this.dataExcel());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FDR');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    this.saveExcelFile(excelBuffer, 'fdr_cuentas_' + this.getDate());
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }




  ActivateAccount(account) {
    this.partiesManagementService.updateFdrAccount({ id: account.accountId, user: account.user, status: 1 }).subscribe(response => {
      if (response != null) {
        this.Toast.fire({ icon: 'success', title: 'Cuenta Activada' });
        this.close();
      }
    },
      error => { console.log(error) })
  }




  getBalance(r: any): number {
    return r.total ?? r.startBalance ?? 0;
  }



  confirmDesactivate() {
    Swal.fire({
      icon: 'warning',
      title: 'Atención ',
      text: '¿Desea dar de baja la cuenta?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });

  }


}



